var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',[(_vm.options.length==0)?_c('option',{attrs:{"value":"Ghana"}},[_vm._v("Ghana")]):_vm._e(),_vm._l((_vm.options),function(country){return _c('option',{domProps:{"value":country}},[_vm._v(_vm._s(country))])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }